import LoadingPage from "components/LoadingPage";
import { lazy, Suspense } from "react";

const Portfolio = lazy(() => import("pages/SitePortfolio"));
const PortfolioSite01 = lazy(() => import("pages/SitePortfolio/site01"));
const PortfolioSite02 = lazy(() => import("pages/SitePortfolio/site02"));

const useRoutersSitePortfolio = () => {
  return [
    {
      path: "/portfolio/",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <Portfolio />
        </Suspense>
      ),
    },
    {
      path: "/portfolio/1",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <PortfolioSite01 />
        </Suspense>
      ),
    },
        {
      path: "/portfolio/2",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <PortfolioSite02 />
        </Suspense>
      ),
    },
  ];
};

export default useRoutersSitePortfolio;
